/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Grid, GridItem } from '@squiz/sds';
import React from 'react';
import { CUSTOMER_PROFILE_GRID_ITEM_KEYS } from '../../CustomerProfile.constants';
import { CustomerBasicAttributes } from '../CustomerBasicAttributes/CustomerBasicAttributes';
import { CustomerOverview } from '../CustomerOverview/CustomerOverview';
import { CustomerRecentEvents } from '../CustomerRecentEvents/CustomerRecentEvents';
import { CustomerDetailsProps } from './CustomerDetails.props';

/**
 * The content of the details tabs on the customer profile screen.
 */
export const CustomerDetails = (props: CustomerDetailsProps): JSX.Element => {
  const { customer } = props;
  const { $customerid } = customer;

  const gridItems: Array<GridItem> = [
    {
      component: (
        <>
          <CustomerOverview customer={customer} />
          <CustomerBasicAttributes {...props} />
        </>
      ),
      componentName: CUSTOMER_PROFILE_GRID_ITEM_KEYS.customerOverview,
      componentSize: {
        colWidth: 6,
        rowHeight: 0,
      },
      key: CUSTOMER_PROFILE_GRID_ITEM_KEYS.customerOverview,
    },
    {
      component: <CustomerRecentEvents />,
      componentName: CUSTOMER_PROFILE_GRID_ITEM_KEYS.customerRecentEvents,
      componentSize: {
        colWidth: 6,
        rowHeight: 0,
      },
      key: CUSTOMER_PROFILE_GRID_ITEM_KEYS.customerRecentEvents,
    },
  ];

  return (
    <div className="customer-details__wrapper">
      <Grid items={gridItems} key={`customer-grid--${$customerid}`} />
    </div>
  );
};
